import React, { useRef, useState } from 'react'
import { Stack, Title, createStyles, Grid, Text, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { Trans, useTranslation } from 'react-i18next'
import step3 from '../../assets/stepper/step3.png'
import RootButton from '../Buttons/RootButton'
import IconWrapper from '../MediaWrappers/IconWrapper'
import sendBlackIcon from '../../assets/icons/send_black.svg'
import sendWhiteIcon from '../../assets/icons/send_white.svg'
import HeaderIconWrapper from '../Header/HeaderIconWrapper'

const useStyles = createStyles(theme => ({
  panel: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    padding: 0,
    width: '100%',
  },
  info: {
    flexDirection: 'column',
    backgroundColor: theme.colors.background[0],
    color: theme.colors.title[0],
    textAlign: 'left',
    maxWidth: '80%',
  },
  textArea: {
    fontSize: '30px',
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: '25px',
    },
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      fontSize: '20px',
    },
  },
  graphic: {
    width: '100%',
    height: '98vh',
    objectFit: 'cover',
    // fade last 50px from image
    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
    [`@media (max-width: ${theme.breakpoints.lg})`]: {
      width: '100%',
      height: '30vh',
    },
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: '100%',
      height: '25vh',
    },
  },
}))

const Step3: React.FC = () => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  const { classes } = useStyles()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`)
  const isDownLg = useMediaQuery(`(max-width: ${theme.breakpoints.lg})`)
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const ref = useRef(null)

  return (
    <Grid sx={{ flexDirection: isDownLg ? 'column-reverse' : 'row' }}>
      <Grid.Col span="auto" className={classes.panel}>
        <Stack className={classes.info} spacing="3em">
          <Title order={isMobile ? 3 : 2}>
            <Trans i18nKey="components.stepper.3.text1">
              Get L1 Betanet
              <br /> Tokens
            </Trans>
          </Title>
          <Text className={classes.textArea}>
            {t(
              'components.stepper.3.text',
              "To begin testing, you'll need to join the LAMINA1 community on Discord and access our faucet."
            )}
          </Text>
          <div
            ref={ref}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <RootButton
              transparent
              leftIcon={
                <HeaderIconWrapper
                  hovered={isHovered}
                  iconDark={sendBlackIcon}
                  iconLight={sendWhiteIcon}
                />
              }
              onClick={() =>
                window.open(
                  'https://medium.com/@LAMINA1/lamina1-quick-start-guide-how-to-get-l1-betanet-test-tokens-fed0d95b8a58',
                  '_blank'
                )
              }
            >
              Get Tokens
            </RootButton>
          </div>
        </Stack>
      </Grid.Col>
      <Grid.Col span="auto" className={classes.panel}>
        <img className={classes.graphic} src={step3} alt="step1" />
      </Grid.Col>
    </Grid>
  )
}

export default Step3
